import { Controller } from "@hotwired/stimulus"

// Module-level: survives controller disconnect/reconnect during Turbo Frame replacement
let pendingCursor = null

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this._timer = null
    if (pendingCursor !== null && this.hasInputTarget) {
      this.inputTarget.focus()
      this.inputTarget.setSelectionRange(pendingCursor, pendingCursor)
      pendingCursor = null
    }
  }

  disconnect() {
    clearTimeout(this._timer)
  }

  search() {
    if (this.hasInputTarget) pendingCursor = this.inputTarget.selectionEnd
    clearTimeout(this._timer)
    this._timer = setTimeout(() => this.element.requestSubmit(), 300)
  }
}
